import { render, staticRenderFns } from "./ValidateResult.vue?vue&type=template&id=01b34695&"
import script from "./ValidateResult.vue?vue&type=script&lang=js&"
export * from "./ValidateResult.vue?vue&type=script&lang=js&"
import style0 from "./ValidateResult.vue?vue&type=style&index=0&id=01b34695&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports